/**
 * 
 * key
 * 
 */


const key = 'cHJpb3JpdHk='

export default key 